<div class="agenda-page">

  <div class="agenda-loading" *ngIf="paso === 'cargando'">
    <span class="spinner-crescent spinner-lg"></span>
  </div>

  <div class="agenda-invalido-card" *ngIf="paso === 'invalido'">
    <div class="agenda-brand-bar agenda-brand-bar-standalone">
      <img class="agenda-brand-logo" [src]="logoUrl" alt="Simpli">
    </div>
    <div class="agenda-invalido-icon">
      <mat-icon inline="true">shield_lock</mat-icon>
    </div>
    <h2>Este link no es válido</h2>
    <p>Verifica el link que te compartieron o solicita uno nuevo.</p>
  </div>

  <div class="agenda-card" *ngIf="ejecutivo && paso !== 'cargando' && paso !== 'invalido'">

    <div class="agenda-brand-bar">
      <img class="agenda-brand-logo" [src]="logoUrl" alt="Simpli">
      <span>Agenda tu reunión con Simpli hoy</span>
    </div>

    <div class="agenda-header">
      <div class="agenda-avatar-wrap">
        <img class="agenda-avatar" [src]="ejecutivo.avatar" *ngIf="ejecutivo.avatar" alt="">
        <div class="agenda-avatar agenda-avatar-iniciales" *ngIf="!ejecutivo.avatar">{{ iniciales }}</div>
      </div>
      <div class="agenda-header-info">
        <h1>{{ ejecutivo.nombre }}</h1>
        <p class="agenda-cargo" *ngIf="ejecutivo.cargo">{{ ejecutivo.cargo }}</p>
        <div class="agenda-meta">
          <span><mat-icon inline="true">schedule</mat-icon> 30 min</span>
          <span class="agenda-meta-sep">·</span>
          <span><mat-icon inline="true">videocam</mat-icon> Google Meet</span>
        </div>
      </div>
    </div>

    <!-- Paso: elegir día y horario -->
    <div class="agenda-body agenda-body-slots" *ngIf="paso === 'slots'">
      <div class="agenda-calendar">
        <h3>Selecciona un día</h3>

        <div class="cal-widget">
          <div class="cal-header">
            <span class="cal-month-label">{{ calendarLabel }}</span>
            <div class="cal-nav">
              <button type="button" class="cal-nav-btn" (click)="prevMonth()" [disabled]="!canGoPrevMonth()">
                <mat-icon inline="true">chevron_left</mat-icon>
              </button>
              <button type="button" class="cal-nav-btn" (click)="nextMonth()">
                <mat-icon inline="true">chevron_right</mat-icon>
              </button>
            </div>
          </div>

          <div class="cal-weekdays">
            <span *ngFor="let d of weekDays">{{ d }}</span>
          </div>

          <div class="cal-week" *ngFor="let week of calendarWeeks">
            <button
              type="button"
              *ngFor="let day of week"
              class="cal-day"
              [class.cal-day-empty]="!day"
              [class.cal-day-disabled]="isDisabledDay(day)"
              [class.cal-day-selected]="isSelectedDay(day)"
              [class.cal-day-today]="isToday(day) && !isSelectedDay(day)"
              [disabled]="isDisabledDay(day)"
              (click)="selectDay(day)">
              <span class="cal-day-num">{{ day ? day.getDate() : '' }}</span>
            </button>
          </div>
        </div>
      </div>

      <div class="agenda-slots">
        <h3>Elige un horario</h3>

        <div class="agenda-error" *ngIf="agendarError">{{ agendarError }}</div>

        <div class="agenda-slots-loading" *ngIf="slotsLoading">
          <span class="spinner-crescent"></span>
        </div>

        <div class="agenda-slots-error" *ngIf="!slotsLoading && slotsError">
          {{ slotsError }}
        </div>

        <div class="agenda-slots-empty" *ngIf="!slotsLoading && !slotsError && !hasSelectedDay">
          <mat-icon inline="true">touch_app</mat-icon>
          <span>Selecciona un día en el calendario<br>para ver los horarios disponibles.</span>
        </div>

        <div class="agenda-slots-empty" *ngIf="!slotsLoading && !slotsError && hasSelectedDay && slots.length === 0">
          <mat-icon inline="true">event_busy</mat-icon>
          <span>No hay horarios disponibles este día.<br>Prueba con otra fecha.</span>
        </div>

        <div class="agenda-slots-list" *ngIf="!slotsLoading && hasSelectedDay && slots.length > 0">
          <button
            type="button"
            class="agenda-slot-btn"
            *ngFor="let slot of slots"
            (click)="elegirSlot(slot)">
            {{ horaSlot(slot) }}
          </button>
        </div>
      </div>
    </div>

    <!-- Paso: formulario -->
    <div class="agenda-body agenda-body-form" *ngIf="paso === 'form' && selectedSlot">
      <button type="button" class="agenda-back" (click)="volverASlots()">
        <mat-icon inline="true">arrow_back</mat-icon> Cambiar horario
      </button>

      <div class="agenda-date-chip">
        <div class="agenda-date-chip-label">Tu reunión</div>
        <div class="agenda-date-chip-row">
          <mat-icon inline="true">calendar_today</mat-icon>
          <span class="agenda-date-chip-main">{{ selectedDate | date:'EEEE d MMMM y':'':'es-CL' }}</span>
        </div>
        <div class="agenda-date-chip-row">
          <mat-icon inline="true">schedule</mat-icon>
          <span class="agenda-date-chip-time">{{ horaSlot(selectedSlot) }} hrs</span>
        </div>
        <div class="agenda-date-chip-row">
          <mat-icon inline="true">videocam</mat-icon>
          <span class="agenda-date-chip-meet">Google Meet</span>
        </div>
      </div>

      <form class="agenda-form" (ngSubmit)="agendar()">
        <div class="agenda-form-row">
          <mat-form-field appearance="outline">
            <mat-label>Nombre de la empresa</mat-label>
            <input
              matInput
              [(ngModel)]="empresaNombre"
              name="empresaNombre"
              required
              [errorStateMatcher]="empresaNombreErrorMatcher"
              (blur)="formTouched = true">
            <mat-error *ngIf="formTouched && !empresaNombre.trim()">La empresa es obligatoria.</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>RUT de la empresa</mat-label>
            <input
              matInput
              [ngModel]="rut"
              (ngModelChange)="onRutInput($event)"
              (blur)="onRutBlur()"
              name="rut"
              placeholder="12345678-9"
              required
              [errorStateMatcher]="rutErrorMatcher">
            <mat-error *ngIf="rutStatus === 'error'">RUT inválido.</mat-error>
          </mat-form-field>
        </div>

        <div class="agenda-form-row">
          <mat-form-field appearance="outline">
            <mat-label>Tu nombre</mat-label>
            <input
              matInput
              [(ngModel)]="contactoNombre"
              name="contactoNombre"
              required
              [errorStateMatcher]="contactoNombreErrorMatcher"
              (blur)="formTouched = true">
            <mat-error *ngIf="formTouched && !contactoNombre.trim()">Tu nombre es obligatorio.</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Tu email</mat-label>
            <input
              matInput
              type="email"
              [(ngModel)]="contactoEmail"
              name="contactoEmail"
              required
              [errorStateMatcher]="contactoEmailErrorMatcher"
              (blur)="formTouched = true">
            <mat-error *ngIf="contactoEmailError">{{ contactoEmailError }}</mat-error>
          </mat-form-field>
        </div>

        <mat-form-field appearance="outline" class="agenda-form-full">
          <mat-label>Comentarios (opcional)</mat-label>
          <textarea matInput [(ngModel)]="comentario" name="comentario" rows="3"></textarea>
        </mat-form-field>

        <div class="agenda-error" *ngIf="agendarError">{{ agendarError }}</div>

        <div class="agenda-submit-row">
          <button
            class="agenda-submit"
            type="submit"
            [disabled]="agendando">
            <span class="spinner-crescent spinner-sm spinner-onColor" *ngIf="agendando"></span>
            <span *ngIf="!agendando">Agendar reunión</span>
          </button>
        </div>
      </form>
    </div>

    <!-- Paso: confirmación -->
    <div class="agenda-body agenda-confirmado" *ngIf="paso === 'confirmado' && confirmacion">
      <div class="agenda-confirmado-icon-wrap">
        <mat-icon class="agenda-confirmado-icon">check</mat-icon>
      </div>
      <h2>Tu reunión está confirmada</h2>
      <p>
        Tu reunión con <b>{{ ejecutivo.nombre }}</b> quedó agendada para el
        <b>{{ confirmacion.fecha }}</b> a las <b>{{ confirmacion.hora }}</b> hrs.
      </p>
      <p class="agenda-confirmado-hint">En unos minutos recibirás la invitación de Google Calendar con el enlace para unirte a la videollamada.</p>

      <div class="agenda-confirmado-actions">
        <button class="agenda-submit" (click)="agendarOtraReunion()">Agendar otra reunión</button>
      </div>
    </div>

  </div>
</div>
